import BreadCrumb from "Components/Common/BreadCrumb";
import { useFormik } from "formik";
import {
  adminGetComboMemberMenus,
  adminGetMemberMenus,
  adminUpdateMemberMenus,
} from "helpers/backend_helpers";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import {
  Card,
  CardBody,
  CardHeader,
  Container,
  Button,
  Spinner,
  Row,
  Col,
  Badge,
} from "reactstrap";
import * as Yup from "yup";

const MenuMemberProperties = () => {
  const [data, setData] = useState<any>([]);
  const [comboData, setComboData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [saving, setSaving] = useState<boolean>(false);

  const getData = () => {
    setLoading(true);
    adminGetMemberMenus()
      .then((response: any) => {
        setData(response);
      })
      .catch(() => {
        toast.error("Gagal memuat data menu");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      menus:
        data?.map((el: any) => {
          return { label: el.readableName, value: el.key };
        }) || [],
    },
    validationSchema: Yup.object({
      menus: Yup.array().min(1, "Menu aplikasi harus diisi!"),
    }),
    onSubmit: (values) => {
      const formattedValues = {
        menus: values?.menus?.map((cat: any) => cat.value),
      };

      setSaving(true);
      adminUpdateMemberMenus(formattedValues)
        .then((response: any) => {
          getData();
          toast.success(
            <div className="d-flex align-items-center">
              <i className="ri-check-line me-2 fs-5"></i>
              Data menu aplikasi berhasil diubah!
            </div>
          );
        })
        .catch((error) => {
          toast.error(
            <div className="d-flex align-items-center">
              <i className="ri-error-warning-line me-2 fs-5"></i>
              Gagal mengubah menu aplikasi
            </div>
          );
        })
        .finally(() => {
          setSaving(false);
        });
    },
  });

  const getCombo = () => {
    adminGetComboMemberMenus()
      .then((response: any) => {
        setComboData(
          response?.map((el: any) => {
            return { label: el.readableName, value: el.key };
          })
        );
      })
      .catch(() => {
        toast.error("Gagal memuat daftar menu");
      })
      .finally(() => {});
  };

  useEffect(() => {
    getData();
    getCombo();
  }, []);

  document.title = "Menu Aplikasi";

  // Custom styles untuk react-select
  const customSelectStyles = {
    control: (base: any, state: any) => ({
      ...base,
      minHeight: "45px",
      borderColor:
        validation.errors.menus && validation.touched.menus
          ? "#f06548"
          : state.isFocused
          ? "#405189"
          : "#ced4da",
      boxShadow: state.isFocused
        ? "0 0 0 0.15rem rgba(64, 81, 137, 0.1)"
        : "none",
      "&:hover": {
        borderColor: state.isFocused ? "#405189" : "#adb5bd",
      },
    }),
    multiValue: (base: any) => ({
      ...base,
      backgroundColor: "#405189",
      borderRadius: "4px",
    }),
    multiValueLabel: (base: any) => ({
      ...base,
      color: "#fff",
      padding: "3px 8px",
    }),
    multiValueRemove: (base: any) => ({
      ...base,
      color: "#fff",
      "&:hover": {
        backgroundColor: "#2e3b5f",
        color: "#fff",
      },
    }),
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Menu Aplikasi" pageTitle="Pengaturan" />

          <Row>
            <Col lg={12} className="mx-auto">
              <Card className="shadow-sm border-0">
                <CardHeader className="bg-white border-bottom">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <h5 className="card-title mb-1">
                        {/* <i className="ri-menu-line me-2 text-primary"></i> */}
                        Pengaturan Menu Aplikasi
                      </h5>
                      <p className="text-muted mb-0 small">
                        Kelola menu yang tersedia untuk member
                      </p>
                    </div>
                    {!loading && validation.values.menus.length > 0 && (
                      <Badge color="primary" className="px-3 py-2">
                        {validation.values.menus.length} Menu Dipilih
                      </Badge>
                    )}
                  </div>
                </CardHeader>

                <CardBody className="p-4">
                  {loading ? (
                    <div className="text-center py-5">
                      <Spinner color="primary" size="lg" />
                      <p className="text-muted mt-3 mb-0">Memuat data...</p>
                    </div>
                  ) : (
                    <form onSubmit={validation.handleSubmit}>
                      <div className="mb-4">
                        <label className="form-label fw-medium">
                          Pilih Menu Aplikasi
                          <span className="text-danger ms-1">*</span>
                        </label>
                        <Select
                          value={validation.values.menus || []}
                          onChange={(e: any) => {
                            validation.setFieldValue("menus", e);
                          }}
                          options={comboData}
                          closeMenuOnSelect={false}
                          isMulti
                          styles={customSelectStyles}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          placeholder="Pilih satu atau lebih menu..."
                          noOptionsMessage={() => "Tidak ada menu tersedia"}
                          isDisabled={saving}
                        />
                        {validation.errors.menus && validation.touched.menus ? (
                          <div className="text-danger small mt-2">
                            <i className="ri-error-warning-line me-1"></i>
                            {validation.errors.menus}
                          </div>
                        ) : (
                          <div className="text-muted small mt-2">
                            <i className="ri-information-line me-1"></i>
                            Pilih menu yang ingin ditampilkan untuk member
                          </div>
                        )}
                      </div>

                      <div className="d-flex gap-2 justify-content-end pt-3 border-top">
                        <Button
                          size="sm"
                          type="button"
                          color="light"
                          onClick={() => {
                            validation.resetForm();
                            getData();
                          }}
                          disabled={saving || loading}
                        >
                          <i className="ri-refresh-line me-1"></i>
                          Reset
                        </Button>
                        <Button
                          size="sm"
                          type="submit"
                          color="primary"
                          disabled={
                            saving || loading || !validation.values.menus.length
                          }
                          className="px-4"
                        >
                          {saving ? (
                            <>
                              <Spinner size="sm" className="me-2" />
                              Menyimpan...
                            </>
                          ) : (
                            <>
                              <i className="ri-save-line me-1"></i>
                              Simpan Perubahan
                            </>
                          )}
                        </Button>
                      </div>
                    </form>
                  )}
                </CardBody>
              </Card>

              {/* Info Card */}
              <Card className="shadow-sm border-0 bg-light">
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-shrink-0">
                      <i className="ri-information-line text-info fs-3"></i>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <h6 className="mb-2">Informasi</h6>
                      <ul className="text-muted small mb-0 ps-3">
                        <li>
                          Menu yang dipilih akan ditampilkan pada aplikasi
                          member
                        </li>
                        <li>Pastikan minimal satu menu dipilih</li>
                        <li>
                          Perubahan akan langsung berlaku setelah disimpan
                        </li>
                      </ul>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default MenuMemberProperties;
